module.exports = __webpack_public_path__ + "img/logo.ab90c916.png";